import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { S25IconComponent } from "../../s25-icon/s25.icon.component";
import { S25StripeSettingsComponent } from "./s25.stripe.settings.component";
import { S25ToggleButtonModule } from "../../s25-toggle-button/s25.toggle.button.module";

@NgModule({
    imports: [CommonModule, FormsModule, S25ToggleButtonModule, S25IconComponent],
    exports: [S25StripeSettingsComponent],
    declarations: [S25StripeSettingsComponent],
    providers: [S25StripeSettingsComponent],
})
export class S25StripeSettingsModule {}
